import { render, staticRenderFns } from "./CargarEdificios.vue?vue&type=template&id=cc418fe6&"
import script from "./CargarEdificios.vue?vue&type=script&lang=js&"
export * from "./CargarEdificios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports